import React from "react";
import LegalLayout from "../components/LegalLayout";

/**
 * Legal Impressum. Rendered verbatim in German across ALL locales, as is
 * legally customary for a DE company (§ 5 DDG). Bracket placeholders are
 * intentional — the client fills them in before public launch.
 */
export default function ImpressumPage() {
  return (
    <LegalLayout
      testid="impressum-page"
      overline="§ 5 DDG"
      title="Impressum"
    >
      <div className="space-y-6 text-slate-700 leading-relaxed" data-testid="impressum-body">
        <section>
          <h2 className="font-heading font-semibold text-lg text-slate-950 mb-1">
            Angaben gemäß § 5 DDG
          </h2>
          <p>
            GT Solutions UG (haftungsbeschränkt)
            <br />
            Dr. Löffellad-Straße 8
            <br />
            86609 Donauwörth
            <br />
            Deutschland
          </p>
          <p className="mt-3">
            Vertreten durch die Geschäftsführerin: Mariavioletta Adinolfi
          </p>
        </section>

        <section>
          <h2 className="font-heading font-semibold text-lg text-slate-950 mb-1">Kontakt</h2>
          <p>
            Telefon: +49 171 5778053
            <br />
            E-Mail:{" "}
            <a
              href="mailto:info@autexio.de"
              className="text-blue-600 hover:text-blue-700 underline underline-offset-2"
              data-testid="impressum-email-link"
            >
              info@autexio.de
            </a>
          </p>
        </section>

        <section>
          <h2 className="font-heading font-semibold text-lg text-slate-950 mb-1">
            Registereintrag
          </h2>
          <p>
            Eintragung im Handelsregister
            <br />
            Registergericht: Amtsgericht Augsburg
            <br />
            Registernummer: HRB 43054
          </p>
          <p className="mt-3">
            Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG: [USt-IdNr. – wird nach Erteilung
            ergänzt]
          </p>
        </section>

        <section>
          <p>
            Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV: Mariavioletta Adinolfi, Anschrift
            wie oben
          </p>
        </section>

        <section>
          <h2 className="font-heading font-semibold text-lg text-slate-950 mb-1">
            Verbraucherstreitbeilegung / Universalschlichtungsstelle
          </h2>
          <p>
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
            Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </section>
      </div>
    </LegalLayout>
  );
}
